import { Row, Col, Card } from 'antd';
import {
  convertCentsIntoDollar,
  formatDate,
} from '../../../helpers/genericHelper';
import CustomText from '../../CustomText';

function PaymentHistoryComponent({ payments = [] }) {
  return (
    <>
      {payments && payments.length > 0 ? (
        payments.map((data) => {
          return (
            <Card
              bordered={false}
              hoverable={true}
              className="criclebox tablespace mb-16"
            >
              <Row className="save-build-box-container" gutter={[30, 30]}>
                <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                  <h4>Date (UTC)</h4>
                  <CustomText
                    dataSet={data}
                    property1={'createTs'}
                    formatter={(val) => formatDate(val, true)}
                  />
                </Col>
                {/* <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                  <h4>Merchant</h4>
                  <CustomText dataSet={data} property1={'descriptor'} />
                </Col> */}

                <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                  <h4>Status</h4>
                  <CustomText dataSet={data} property1={'paymentStatus'} />
                </Col>
                {/* <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                  <h4>Type</h4>
                  <CustomText
                    dataSet={{ ...data, type: data.type || TRANSACTION_STRING }}
                    property1={'type'}
                  />
                </Col> */}

                <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                  <h4>Instant Reward</h4>
                  <CustomText dataSet={data} property1={'avaPayment'} />
                </Col>

                <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                  <h4>Manual Payment</h4>
                  <CustomText dataSet={data} property1={'manualPayment'} />
                </Col>

                <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                  <h4>Retry Count</h4>
                  <CustomText dataSet={data} property1={'retryCount'} />
                </Col>

                <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                  <h4>Amount</h4>
                  <CustomText
                    dataSet={data}
                    property1={'amount'}
                    formatter={convertCentsIntoDollar}
                  />
                </Col>
                <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                  <h4>Payment failure reason</h4>
                  <CustomText
                    dataSet={data}
                    property1={'paymentFailedReason'}
                  />
                </Col>

                <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                  <h4>Payment Mode</h4>
                  <CustomText
                    dataSet={data}
                    property1={'paymentMode'}
                  />
                </Col>

                <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                  <h4>Payment Due Date</h4>
                  <CustomText
                    dataSet={data}
                    property1={'paymentDueDate'}
                    formatter={formatDate}
                  />
                </Col>

                <Col xs={24} sm={12} md={8} xl={6} xxl={4}>
                  <h4>Payment Success Time</h4>
                  <CustomText
                    dataSet={data}
                    property1={'paymentSuccessInstant'}
                    formatter={(val) => formatDate(val, true)}
                  />
                </Col>
              </Row>
            </Card>
          );
        })
      ) : (
        <Row className="no-data-card">No Payments Found</Row>
      )}
    </>
  );
}

export default PaymentHistoryComponent;
